import { themeVars } from '../theme/vars';
import { borderRadius, boxShadows, space } from '../tokens';
import { typography } from '../typography';
import { fadeIn, slideInFromTop } from '../animations.css';
import { style } from '../layer.css';

export const comboboxRoot = style({
  position: 'relative',
});

export const searchIcon = style({
  flexShrink: 0,
});

export const comboboxReset = style({
  visibility: 'visible',

  selectors: {
    '&[data-hidden]': {
      visibility: 'hidden',
    },
  },
});

export const comboboxList = style({
  backgroundColor: themeVars.container.primary.background.idle,
  padding: `${space.s4}px 0`,
  overflowY: 'scroll',
  overscrollBehavior: 'contain',
  height: `calc(var(--cmdk-list-height) + ${space.s8}px)`,

  transition: 'height 100ms ease',
  animationDuration: '400ms',
  animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
  animationFillMode: 'forwards',

  willChange: 'height, transform, opacity',

  selectors: {
    '&[data-state="open"]': {
      display: 'block',
      animationName: `${slideInFromTop}, ${fadeIn}`,
    },
    '&[data-state="closed"]': {
      visibility: 'hidden',
    },
  },
});

export const comboboxPopoverList = style({
  boxShadow: boxShadows.default,
  borderRadius: borderRadius.r8,
  outline: `1px solid ${themeVars.container.border.default}`,
  outlineOffset: '-1px',
  maxHeight: '600px',
  width: 'var(--radix-popover-trigger-width)',
});

export const comboboxEmpty = style({
  selectors: {
    '&:not(:empty)': {
      ...typography['bodyMd'],
      color: themeVars.controls.foreground.default,
      padding: `${space.s8}px ${space.s12}px`,
      display: 'flex',
      alignItems: 'center',
      minHeight: 34,
    },
  },
});

export const comboboxItem = style({
  minHeight: 34,
  padding: `${space.s8}px ${space.s12}px`,
  margin: `0 ${space.s4}px`,
  borderRadius: borderRadius.r4,
  backgroundColor: themeVars.dropdownMenu.background.default,

  selectors: {
    '&[data-selected="true"]': {
      backgroundColor: themeVars.dropdownMenu.background.hover,
    },

    '&:active': {
      backgroundColor: themeVars.dropdownMenu.background.active,
    },
  },
});
export const comboboxItemSkeleton = style({
  padding: `${space.s8}px ${space.s12}px`,
});
